import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/popover/style";
import _Popover from "antd/lib/popover";
import "antd/lib/icon/style";
import _Icon from "antd/lib/icon";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { connect } from 'dva';
import BossTable from "../../../Common/BossTable";
import { injectIntl } from "react-intl";
var AppFlowStat = /*#__PURE__*/function (_React$Component) {
  _inherits(AppFlowStat, _React$Component);
  function AppFlowStat(props) {
    var _this;
    _classCallCheck(this, AppFlowStat);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppFlowStat).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "searchA", function () {
      _this.props.dispatch({
        type: "ci0301Info/getStatisticsA",
        payload: {
          tableFlag: true,
          item: "appBand",
          companyid: _this.props.companyid,
          start_tm: _this.props.start_tm,
          end_tm: _this.props.end_tm,
          top: _this.props.data_num,
          dst_ip: _this.state.desIpA,
          dst_port: _this.state.desPortA
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeSrcIpA", function (e) {
      _this.setState({
        srcIpA: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeDesIpA", function (e) {
      _this.setState({
        desIpA: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeDesPortA", function (e) {
      _this.setState({
        desPortA: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "editAppName", function (e) {
      _this.setState({
        appName: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "submitAppNameEditA", function (visible, record) {
      if (visible) {
        _this.setState({
          appName: record.name
        });
      } else {
        _this.props.dispatch({
          type: "ci0301Info/update_app_nameA",
          payload: {
            edit: {
              id: record.id,
              name: _this.state.appName
            },
            refresh: {
              tableFlag: true,
              item: "appBand",
              companyid: _this.props.companyid,
              start_tm: _this.props.start_tm,
              end_tm: _this.props.end_tm,
              top: _this.props.data_num,
              src_ip: _this.state.srcIpA,
              dst_ip: _this.state.desIpA,
              dst_port: _this.state.desPortA
            }
          }
        });
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCheckSrcIpModalShow", function (record) {
      _this.setState({
        srcIpModalShow: true,
        selectedDstIp: record.dst_ip,
        selectedDstPort: record.dst_port
      }, function () {
        this.props.dispatch({
          type: "ci0301Info/get_srcip_list",
          payload: {
            start_tm: this.props.start_tm,
            end_tm: this.props.end_tm,
            companyid: this.props.companyid,
            dst_ip: this.state.selectedDstIp,
            dst_port: this.state.selectedDstPort,
            name: record.name
          }
        });
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCloseCheckSrcIpModal", function () {
      _this.setState({
        srcIpModalShow: false
      });
    });
    _this.state = {
      srcIpA: "",
      desIpA: "",
      desPortA: "",
      srcIpModalShow: false
    };
    return _this;
  }
  _createClass(AppFlowStat, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var pagination = {
        pageSize: 20
      };
      var columnsA = [{
        title: '@应用程序',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        render: function render(index, record) {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: 8
            }
          }, record.name), /*#__PURE__*/React.createElement(_Popover, {
            trigger: "click",
            title: "\u4FEE\u6539\u5E94\u7528\u7A0B\u5E8F\u540D\u79F0",
            content: /*#__PURE__*/React.createElement(_Input, {
              placeholder: "\u8BF7\u8F93\u5165\u5E94\u7528\u7A0B\u5E8F\u540D\u79F0",
              onChange: _this2.editAppName,
              defaultValue: record.name
            }),
            onVisibleChange: function onVisibleChange(visible) {
              return _this2.submitAppNameEditA(visible, record);
            }
          }, /*#__PURE__*/React.createElement(_Icon, {
            style: {
              color: "rgb(24, 144, 255)"
            },
            type: "edit"
          })));
        }
      }, {
        title: '@源地址',
        dataIndex: 'src_ip',
        key: 'src_ip',
        render: function render(index, record) {
          return /*#__PURE__*/React.createElement("span", {
            onClick: function onClick() {
              return _this2.handleCheckSrcIpModalShow(record);
            }
          }, "any");
        }
      }, {
        title: '@目标地址',
        dataIndex: 'dst_ip',
        key: 'dst_ip'
      }, {
        title: '@目标端口',
        dataIndex: 'dst_port',
        key: 'dst_port'
      }, {
        title: '@协议',
        dataIndex: 'protocol',
        key: 'protocol'
      }];
      var srcIpColumns = [{
        title: '@应用程序',
        dataIndex: 'name',
        key: 'name'
      }, {
        title: '@源地址',
        dataIndex: 'src_ip',
        key: 'src_ip'
      }, {
        title: '@目标地址',
        dataIndex: 'dst_ip',
        key: 'dst_ip'
      }, {
        title: '@目标端口',
        dataIndex: 'dst_port',
        key: 'dst_port'
      }];
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
        style: {
          height: 500,
          width: document.body.clientWidth - 300
        },
        id: "chartA"
      })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(BossTable, {
        pagination: pagination,
        columns: columnsA,
        dataSource: this.props.ci0301Info.tableDataA
      })), /*#__PURE__*/React.createElement(_Modal, {
        title: "@源地址",
        onCancel: this.handleCloseCheckSrcIpModal,
        visible: this.state.srcIpModalShow,
        footer: null
      }, /*#__PURE__*/React.createElement(BossTable, {
        columns: srcIpColumns,
        bordered: true,
        size: "small",
        dataSource: this.props.ci0301Info.srcIpList
      })));
    }
  }]);
  return AppFlowStat;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0301Info = _ref.ci0301Info;
  return {
    ci0301Info: ci0301Info
  };
}
export default connect(mapDispatchToProps)(injectIntl(AppFlowStat));